var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"has-icon has-text-link is-unselectable",on:{"click":() => { _vm.print() }}},[_c('span',{staticClass:"icon",class:{'is-loading': _vm.isLoading }},[_c('font-awesome-icon',{attrs:{"icon":['far', 'print']}})],1),_c('span',{domProps:{"textContent":_vm._s(_vm.$t('Form.Control.Print'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }